<template>
	<div v-if="show" style="width: 100%;">
		<!-- 没有数据 -->

		<div class="data_none FlexColumn">
			<img src="~assets/img/no_permission.png" alt="">
			<div class="none_txt">
				暂无权限查看
			</div>
		</div>

		<!--  -->

	</div>
</template>

<script>
	export default {
		name: "powershow",
		components: {

		},
		props: {
			show: {
				type: Boolean,
				default: false,
			},

		},
		data() {
			return {
			}
		}
	}
</script>

<style scoped lang="scss">
	.data_none {
		width: 100%;
		min-height: 550px;

		image {
			width: 400px;
			display: block;
		}

		.none_txt {
			color: rgba(166, 166, 166, 1);
			font-size: 16px;
			margin-top: 20px;
		}
	}
</style>
